import { render, staticRenderFns } from "./truth_h5_cn.vue?vue&type=template&id=41ad938d&scoped=true&"
import script from "./truth_h5_cn.vue?vue&type=script&lang=js&"
export * from "./truth_h5_cn.vue?vue&type=script&lang=js&"
import style0 from "./truth_h5_cn.vue?vue&type=style&index=0&id=41ad938d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ad938d",
  null
  
)

export default component.exports